export type Phone = string;

export const phoneValidation = "[+]?(\\d+-)*(\\d)+";
